import { Container, Grid, Link } from "@mui/material";
import React from "react";

import telegram from "../../images/telegram.png"
import twitter from "../../images/twitter.png"
import redit from "../../images/redit.png"

const Community = () => {
    return(
        <div id="community" className="OS---ThreeTogether py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="py-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading">Community</h2>
                    </Grid>
                    <Grid
                        xs={12}
                        sm={8}
                        lg={6}
                    >
                        <p className="text-center">Our community grows stronger every day. Please follow our social platforms to get the most up-to-date, accurate OhmniShiba information.</p>
                    </Grid>
                    <Grid
                        xs={12}
                     />
                    <Grid
                        xs={12}
                        sm={8}
                        lg={6}
                        className="text-center mt-4"
                    >
                        <Link href="#" className="d-inline-block mx-3">
                            <img src={telegram} className="img-fluid mb-2" style={{maxWidth: 40}} />
                            <p>Telegram</p>
                        </Link>
                        <Link href="#" className="d-inline-block mx-3">
                            <img src={twitter} className="img-fluid mb-2" style={{maxWidth: 40}} />
                            <p>Twitter</p>
                        </Link>
                        <Link href="#" className="d-inline-block mx-3">
                            <img src={redit} className="img-fluid mb-2" style={{maxWidth: 40}} />
                            <p>Redit</p>
                        </Link>
                    </Grid>
                </Grid>
            </Container>  
        </div>
    );
}

export default Community;